export default __webpack_public_path__ + "static/media/redActiveSvg.39a4c0fd.svg";